<!-- 真相搜索主页 -->


<template>
  <div class="search_container">
    <!--<img class="bg_img" src="../assets/hp_background.png">-->
    <div class="search_area">
      <img class="search_logo" src="../assets/truthso_search_logo2.png">
      <div class="search_box">
        <input placeholder="" v-model.trim="keyword" @keydown.enter="search" maxlength="30">
        <!--<input placeholder="" :value="keyword" @keydown.enter="search" @change="keywordCheck">-->
        <img v-show="!isShowHover"  @mousemove="changeImg(true)" @mouseleave="changeImg(false)" src="../assets/search_button.png" @click="search">
        <img v-show="isShowHover"  @mousemove="changeImg(true)" @mouseleave="changeImg(false)" src="../assets/search_button_hove.png" @click="search">
        <!--<div class="img" @click="search"></div>-->
        <!--<div class="button"></div>-->
      </div>
      <img class="search_declare" src="../assets/truthso_declare.png">
    </div>

  </div>

</template>

<script>
  import $ from 'jquery';
  import tools from '@/lib/tools'
 
  export default{
    name: 'index',
    data () {
        return {
          keyword:'',
          redirect: '',
          isShowHover:false
        }
    },
    created () {
      this.$store.commit('setCurrentHeader', 'index');
    },
    mounted(){ //页面初始化
      this.init();
    },
    methods: {
      changeImg(flag){
        this.isShowHover=flag;
      },
      init: function(){
        $('.bg_img').css({
          width: $(window).width() + 'px',
          height: $(window).height() + 'px'
        });

        this.$store.commit('showSubBar', false);
        this.$store.commit('showSFooter', true);
        this.$store.commit('showSBg', true);
        this.$store.commit('showContentFooter', false);
        let queries = this.$queryUrlParams();
        if(queries.redirect){
          this.$store.state.redirect = decodeURIComponent(queries.redirect);
        }

        // if(queries.action == 'login'){
        //   this.$store.commit('showPopWindow', 'loginWin');
        // }
      },
      search () {
          if(this.$store.state.user==null){
            this.keyword = '';
            this.$store.commit('showPopWindow', 'loginWin');
          }else{
            if(this.keyword){
            this.$store.state.keyword = this.keyword;
            this.$router.push({path:'/results/text',query:{
                keyword: encodeURIComponent(this.keyword),
                pageNum: 1
              }});
            } else {
                this.$store.dispatch('showMsgModal',{
                  autoClose:true,
                  info:'搜索内容不能为空'
                })
            }
          }
          // if(this.keyword){
          //   this.$store.state.keyword = this.keyword;
          //   this.$router.push({path:'/results/text',query:{
          //       keyword: encodeURIComponent(this.keyword),
          //       pageNum: 1
          //   }});
          // } else {
          //     this.$store.dispatch('showMsgModal',{
          //       autoClose:true,
          //       info:'搜索内容不能为空'
          //     })
          // }
      },
      keywordCheck(event){
          // console.log('keywordCheck:', event.target.value);
          this.keyword = this.$cutString(event.target.value, 30, false);
      }
    },
    beforeRouteLeave (to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
      this.$store.commit('showSubBar', true);
      this.$store.commit('showSFooter', false);
      this.$store.commit('showSBg', false);
      this.$store.commit('showContentFooter', true);
//      this.$emit('leavingHomepage');
      next();
    },
    watch: {
      '$route' (to, from) {
        //刷新参数放到这里里面去触发就可以刷新相同界面了
        this.init();
      }
    },
    computed: {
    }
  }
</script>

<style scoped lang="scss">
  /*.bg_img {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }*/

  .search_area {
    position: relative;
    width: 570px;
    margin: 65px auto;
    overflow: hidden;
    margin-bottom: 80px;
  }

  .search_logo {
    display: block;
    height: 48px;
    margin: 0 auto;
  }
  .search_declare {
    display: block;
    margin: 15px auto 0;
    position:relative;
    left:9px;
    height: 22px;
  }
  .search_box {
    margin-top: 15px;
    width: 560px;
    /*position: relative;*/

    /*height: 42px;*/
  }

  .search_box input {
    box-sizing: border-box;
    height: 42px;
    width: 512px;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    // border: 2px solid #a32935;
border:0px;
    font-size: 16px;
    padding: 10px 10px;
  }

  /*.search_box .img {*/
    /*width: 49px;*/
    /*height: 42px;*/
    /*position: absolute;*/
    /*background: url('../assets/search_button.png') no-repeat;*/
    /*background-size: 100% 100%;*/
    /*right: 0;*/
    /*top: 0;*/
    /*cursor: pointer;*/
    /*border-top-right-radius: 4px;*/
    /*border-bottom-right-radius: 4px;*/
  /*}*/

  .search_box img {
    width: 49px;
    height: 42px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  @media screen and (min-height: 900px) and  (min-width: 1900px) {
       .search_area {
        position: relative;
        width: 570px;
        margin: 145px auto;
          margin-bottom: 80px;
        overflow: hidden;
      }
    }
    /* //苹果pc */
     @media screen and (min-height: 960px) and  (min-width: 1900px) {
        .search_area {
          position: relative;
          width: 570px;
          margin: 145px auto;
          margin-bottom: 80px;
          overflow: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// Index.vue?3ed30bd6